import styled, { css } from "styled-components";

interface CourseContainerProps {
  type?: string;
  show?: boolean;
}

export const FlexContainer = styled.div`
  a {
    text-decoration: none;
  }
`;

export const Container = styled.div<CourseContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 15px;
  border-radius: 4px;
  transition: width 0.4s, height 0.4s;
  margin-top: 0px;
  border-radius: 5px;
  overflow: hidden;
  background: #0f0f0f;

  &:hover {
    transition: all 0.2s ease;
    transform: scale(1.25);
    margin-top: -80px;
    box-shadow: rgb(0 0 0 / 90%) 0px 0px 8px;
  }

  ${(props) =>
    props.type === "horizontal" &&
    css`
      width: 260px;
      height: auto;
    `}

  ${(props) =>
    props.type === "vertical" &&
    css`
      width: 110px;
      height: 150px;
    `}

  ${(props) =>
    props.type === "category" &&
    css`
      margin: 0;
      width: 120px;
      height: 160px;
    `}

  img {
    object-fit: cover;
    border-radius: 5px;

    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    transition: transform 0.8s, width 0.4s, height 0.4s;
    padding: 0;
    margin: 0;

    ${(props) =>
      props.type === "horizontal" &&
      css`
        width: 100%;
        height: 130px;
      `}

    ${(props) =>
      props.type === "vertical" &&
      css`
        width: 110px;
        height: 150px;
      `}

    ${(props) =>
      props.type === "category" &&
      css`
        width: 120px;
        height: 160px;
      `}
  }


`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  flex-basis: min-content;
  cursor: pointer;

  > svg {
    color: #fff;
    border: 1px solid #fff;
    border-radius: 50%;
    font-size: 46px;
    padding: 2px;
    width: 22px;
    height: 22px;

    &:hover {
      background-color: #fff;
      color: #000;
      border: 1px solid #000;
    }
  }

  > p {
  font-weight: 500;
  font-size: 10px;
  margin-top: 1px;
  text-align: center;
    width: auto !important;
    min-width: 55px;
  }
`;

export const ContentCardWrap = styled.div<CourseContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 1;
  z-index: 2;
  transition: all 0.2s ease;
  padding: 10px 10px 15px 10px;
  background: rgb(34, 34, 34);
  height: auto;

  p.whitecolor {
  white-space:nowrap;
      overflow:hidden;
   color: #ffffff;
      font-size: 12px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  ${(props) =>
    props.show === false &&
    css`
      background: transparent;
      opacity: 0;
      z-index: -1;
      height: 0;
    `}

  strong.colored {
  margin-top: 5px;
  padding-top: 10px;
          font-weight: 600;
          font-size: 14px;
    color: #fed44a;
  }

  div {
    &.card_button {
      p {
        color: #fed44a;
        text-align: center;
      }

      > button {
        margin: 0;
        width: auto;
        height: auto;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 20px;

        > svg {
          margin-right: 5px;
          font-size: 18px;
        }
      }
    }
  }
`;

export const PreContentCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 5px 0 0 0;

  p {
    font-family: "Roboto Regular", sans-serif;
    color: #fff;
    font-size: 14px;
    width: auto !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;


    &.whitecolor {
          color: #ffffff;
          font-weight: 600;
          font-size: 14px;
    }

    &.colored {
            text-align: right;
          color: #fed44a;
          font-weight: 600;
          font-size: 14px;
    }

    &.colored2 {
      text-align: right;
      font-weight: 500;
              color: #aaaaaa;
              font-size: 12px;
    }

    strong.colored {
      color: #fed44a;
    }
  }
`;
